module.exports = __webpack_public_path__ + "static/media/TP_Icon_BottleOpener.3a1772d9.png";